import { SetStateAction } from "react";
import { updateWindowValue } from "../functions/updateWindowValue";
import { stdObject } from "../../../data/types/stdObject";
import { salesCodes } from "../../../data/main";
import { toPrice } from "../../../utils/toPrice";
import { colors } from "../../../data/colors";
import { toFixedDecimal } from "../../../utils/toFixedDecimal";

export const itemOptionsModal = ({
  t,
  user,
  docValues,
  modalData,
  windowValues,
  packUpdateWindow,
  updateItemInfo,
  closeMsg,
}: stdObject) => {
  const sumPercent =
    "commissions" in windowValues
      ? windowValues.commissions.reduce(
          (acc: number, curr: stdObject) => acc + Number(curr?.PROCOY ?? 0),
          0,
        )
      : 0;

  const sumCommPrice =
    "commissions" in windowValues
      ? windowValues.commissions.reduce(
          (acc: number, curr: stdObject) =>
            curr && "BASCOY" in curr
              ? (acc += (curr.PRECOY * curr.PROCOY) / 100)
              : acc,

          0,
        )
      : 0;

  const profitAccess = user.RENT && salesCodes.includes(docValues.type);

  const totalProfit = profitAccess
    ? windowValues.price - windowValues.cost - sumCommPrice
    : 0;

  const totalPerProfit = profitAccess
    ? (totalProfit * 100) / windowValues.price
    : 0;

  return {
    title: modalData.title,
    inputs: [
      modalData.index > -1 && {
        label: t("p.description"),
        value: windowValues.description,
        tabId: 0,
        type: "text",
        style: { width: 300 },
        onChange: (v: { target: { value: SetStateAction<string> } }) =>
          updateWindowValue({
            code: "description",
            value: v.target.value,
            ...packUpdateWindow,
          }),
      },
      ...(user[`${docValues.type}COMUS1`] &&
      "commissions" in modalData &&
      "commissions" in windowValues &&
      Array.isArray(windowValues.commissions)
        ? modalData.commissions
            .filter(
              (_: stdObject, index: number) => windowValues.commissions[index],
            )
            .map((e: stdObject, index: number) => {
              return {
                ...e,
                value: Number(windowValues.commissions[index]?.PROCOY),
                tabId: 0,
                type: "number",
                active: user[`${docValues.type}COMUS1`] === 2 && e.active,
                innerStyle: { width: 50 },
                suffix: `%${e.active ? "" : ` (${t("p.paid")})`}`,
                onChange: (v: { target: { value: SetStateAction<string> } }) =>
                  updateWindowValue({
                    key: "commissions",
                    code: index,
                    field: "PROCOY",
                    value: v.target.value,
                    ...packUpdateWindow,
                  }),
              };
            })
        : []),
      ...(user.PCO && "info" in modalData
        ? modalData.info.map((e: stdObject) => {
            return {
              label: t(e.label),
              value: e.value,
              tabId: 0,
              type: "info",
              style: e.style ?? {},
            };
          })
        : []),
      user[`${docValues.type}COMUS1`] &&
        salesCodes
          .filter((e: string) => e !== "COT")
          .includes(docValues.type) && {
          label: t("p.commissions"),
          value:
            "commissions" in windowValues
              ? `${toPrice(sumCommPrice)} (${sumPercent}%)`
              : "",
          tabId: 0,
          type: "info",
        },
      profitAccess && {
        label: t("p.profitability"),
        value: `${toPrice(totalProfit)} (${toFixedDecimal(totalPerProfit, 2)}%)`,
        tabId: 0,
        type: "info",
        style: {
          color: totalProfit > 0 ? colors.green : colors.red,
        },
      },
      {
        code: "REC",
        records: modalData.records,
        tabId: 2,
      },
    ],
    tabs: [
      { code: 0, label: t("p.general") },
      // modalData.serie && { code: 1, label: t("p.series") },
      { code: 2, label: t("p.records") },
    ],
    style: { height: 400 },
    buttons: [
      {
        label: t("p.update"),
        onClick: updateItemInfo,
        color: colors.green,
      },
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
